import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        currentwisher: "",
        menuflag: false,
        menuheight: 0,
        hideNavBar: false,
        heartflag: false,
        heartnum: -1,
    },
    actions: {
        
    },
    mutations: {
    
    }
})

export default store;